import { useContext } from 'react';

import FontIconButton from '@atom/components/common/FontIconButton';
import { ViewListIcon } from '@atom/mui/icons';
import colors from '@atom/styles/colors';
import { FormFieldType } from '@atom/types/form';
import { InventorySchemaTreeType } from '@atom/types/schema';

import FormBuilderContext from './FormBuilderContext';
import Toolbar from './Toolbar';

import classes from './formBuilder.module.css';

const styles = {
  icon: {
    padding: '0px',
    height: '40px',
    width: '40px',
  },
  fillerStyles: {
    position: 'relative',
  },
};

export interface Props {
  inventorySchemaTree: InventorySchemaTreeType;
  loadingInventorySchemaTree: boolean;
  loadingFormTemplateUpdate: boolean;
  onToggle: (data: any[], boolean: boolean) => void;
  toggleDrawer: () => void;
  addField: (type: string) => void;
  addFormModule: (
    type: string,
    inspectionId?: string,
    schemaId?: string,
  ) => void;
  addAssetField: (assetField: FormFieldType, schemaId: string) => void;
}

const ToolbarBase = ({
  toggleDrawer,
  addField,
  inventorySchemaTree,
  loadingInventorySchemaTree,
  loadingFormTemplateUpdate,
  onToggle,
  addAssetField,
  addFormModule,
}: Props) => {
  const { isDrawerOpen } = useContext(FormBuilderContext);

  return (
    <div className={classes.toolbarContainer}>
      {!isDrawerOpen ? (
        <div className={classes.toolbarSection}>
          <FontIconButton
            style={styles.icon}
            onClick={toggleDrawer}
            tooltip="Tabs"
            color={colors.neutral.gray}
            icon={ViewListIcon}
          />
        </div>
      ) : (
        <div style={styles.fillerStyles} />
      )}
      <Toolbar
        addField={addField}
        inventorySchemaTree={inventorySchemaTree}
        loadingInventorySchemaTree={loadingInventorySchemaTree}
        loadingFormTemplateUpdate={loadingFormTemplateUpdate}
        onToggle={onToggle}
        addAssetField={addAssetField}
        addFormModule={addFormModule}
      />
    </div>
  );
};

export default ToolbarBase;
